module.exports = __webpack_public_path__ + "img/menu-hamburger.1c11075f.svg";